<template>
  <div :style="{display: active ? 'block' : 'none'}">
    <slot />
  </div>
</template>

<script>
	export default {
		name: 'ConditionalSection',
    props: {
		  active: Boolean
    }
	};
</script>

<style scoped>

</style>
